// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* OfficerDashboard.css */

/* --- Variables --- */
:root {
  --spacing-gap: 24px; /* Base gap for rows */
  --bg-color: #e8f7e0;
}

/* --- Main Container --- */
.officer-dashboard-container {
  padding: 16px;
  background-color: var(--bg-color);
  min-height: 100vh;
}

@media (min-width: 900px) {
  .officer-dashboard-container {
    padding: 32px;
  }
}

/* --- Header --- */
.dashboard-header {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 32px;
}

@media (min-width: 600px) {
  .dashboard-header {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}

.header-actions {
  display: flex;
  gap: 16px;
  flex-direction: column;
}

@media (min-width: 600px) {
  .header-actions {
    flex-direction: row;
  }
}

/* --- Common Row Styles --- */
.dashboard-row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-gap);
  margin-bottom: var(--spacing-gap);
  width: 100%;
}


.row-stats{
  align-items: center;
  justify-content: space-evenly;
}

.card-stat {
  width: calc(50% - (var(--spacing-gap) / 2));
  margin-bottom: 0; /* Gap handled by flex gap */
}

@media (min-width: 600px) {
  .card-stat {
    width: calc(33.33% - (2 * var(--spacing-gap) / 3));
  }
}

@media (min-width: 1200px) {
  .card-stat {
    width: calc(16.666% - (5 * var(--spacing-gap) / 6));
  }
}

/* --- 2. Charts Logic --- */
.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 16px;
}

.date-filters {
  display: flex;
  gap: 16px;
  align-items: center;
}

/* Mobile: Full width */
.card-chart {
  width: 100%;
}

/* Desktop: 2 per row (50% width minus gap) */
@media (min-width: 900px) {
  .card-chart {
    width: calc(50% - (var(--spacing-gap) / 2));
  }
}

/* --- 3. Maps Logic --- */
/* Mobile: Full width */
.card-map {
  width: 100%;
}

/* Desktop: 2 per row (50% width minus gap) */
@media (min-width: 900px) {
  .card-map {
    width: calc(50% - (var(--spacing-gap) / 2));
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Dashboard/OfficerDashboard.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB,sBAAsB;AACtB;EACE,mBAAmB,EAAE,sBAAsB;EAC3C,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,iCAAiC;EACjC,WAAW;AACb;;;AAGA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB,EAAE,4BAA4B;AAChD;;AAEA;EACE;IACE,kDAAkD;EACpD;AACF;;AAEA;EACE;IACE,mDAAmD;EACrD;AACF;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,WAAW;AACb;;AAEA,6CAA6C;AAC7C;EACE;IACE,2CAA2C;EAC7C;AACF;;AAEA,0BAA0B;AAC1B,uBAAuB;AACvB;EACE,WAAW;AACb;;AAEA,6CAA6C;AAC7C;EACE;IACE,2CAA2C;EAC7C;AACF","sourcesContent":["/* OfficerDashboard.css */\n\n/* --- Variables --- */\n:root {\n  --spacing-gap: 24px; /* Base gap for rows */\n  --bg-color: #e8f7e0;\n}\n\n/* --- Main Container --- */\n.officer-dashboard-container {\n  padding: 16px;\n  background-color: var(--bg-color);\n  min-height: 100vh;\n}\n\n@media (min-width: 900px) {\n  .officer-dashboard-container {\n    padding: 32px;\n  }\n}\n\n/* --- Header --- */\n.dashboard-header {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 32px;\n}\n\n@media (min-width: 600px) {\n  .dashboard-header {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n\n.header-actions {\n  display: flex;\n  gap: 16px;\n  flex-direction: column;\n}\n\n@media (min-width: 600px) {\n  .header-actions {\n    flex-direction: row;\n  }\n}\n\n/* --- Common Row Styles --- */\n.dashboard-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--spacing-gap);\n  margin-bottom: var(--spacing-gap);\n  width: 100%;\n}\n\n\n.row-stats{\n  align-items: center;\n  justify-content: space-evenly;\n}\n\n.card-stat {\n  width: calc(50% - (var(--spacing-gap) / 2));\n  margin-bottom: 0; /* Gap handled by flex gap */\n}\n\n@media (min-width: 600px) {\n  .card-stat {\n    width: calc(33.33% - (2 * var(--spacing-gap) / 3));\n  }\n}\n\n@media (min-width: 1200px) {\n  .card-stat {\n    width: calc(16.666% - (5 * var(--spacing-gap) / 6));\n  }\n}\n\n/* --- 2. Charts Logic --- */\n.chart-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.date-filters {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n/* Mobile: Full width */\n.card-chart {\n  width: 100%;\n}\n\n/* Desktop: 2 per row (50% width minus gap) */\n@media (min-width: 900px) {\n  .card-chart {\n    width: calc(50% - (var(--spacing-gap) / 2));\n  }\n}\n\n/* --- 3. Maps Logic --- */\n/* Mobile: Full width */\n.card-map {\n  width: 100%;\n}\n\n/* Desktop: 2 per row (50% width minus gap) */\n@media (min-width: 900px) {\n  .card-map {\n    width: calc(50% - (var(--spacing-gap) / 2));\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
